export const formWidth = 589;
export const gameScreenButtonWidth = 364;
export const buttonHeight = 111;
export const buttonFontSize = 42;